import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { navigate, useLocation } from "@reach/router";
import { scroller } from "react-scroll";
import theme from "../../../assets/theme";
import MenuIcon from "@material-ui/icons/Menu";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  Drawer,
  Button,
} from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "openSans-SemiBold, sans-serif",
    "&.MuiButton-root": {
      minWidth: "auto",
    },
    [theme.breakpoints.up(640)]: {
      "&.MuiButton-root": {
        minWidth: "64px",
      },
    },
  },
  drawerPaper: {
    width: "250px",
    position: "absolute",
    top: 0,
    right: 0,
    height: "auto", // Full height
    padding: 10,
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  arrow: {
    fontSize: "small",
  },
  list: {
    width: "100vw",
    [theme.breakpoints.up(640)]: {
      width: "800px",
    },
  },
  fullList: {
    width: "unset",
  },
  padder: {
    paddingTop: "64px",
  },
  sidePadder: {
    paddingLeft: "2%",
    paddingRight: "5%",
    margin: 0,
    boxShadow: "none",
    borderBottom: "1px solid #e8e8e8",
  },
  listPadder: {
    padding: 0,
  },
}));

export default function DropDownMenu(props) {
  const classes = useStyles();
  const [state, setState] = React.useState(false);
  const location = useLocation();

  const toggleDrawer = (open) => {
    setState(open);
  };

  const list = () => (
    <div
      className={clsx(classes.list, classes.fullList, classes.padder)}
      role="presentation"
      onKeyDown={() => toggleDrawer(false)}
    >
      <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            {props.options.map((option) => (
              <MenuItem
                key={option.name}
                style={{
                  color:
                    option.name === "Log Out" || option.name === "Sign Out"
                      ? "#d91b1b"
                      : location?.hash?.includes(option?.name?.toLowerCase())
                      ? props.activeMenuButtonTextColor
                      : props.color
                      ? props.color
                      : COLORS.COLOR_DARK,
                  fontFamily: theme.fonts.primaryFontSemiBold,
                  fontSize: "14px",
                  display: option?.hidden ? "none" : "",
                }}
                onClick={() => {
                  option.name === "Log Out" || option.name === "Sign Out"
                    ? option.props.onClick()
                    : navigate(option.link);
                  setState(false);
                  scroller.scrollTo(option.section ? option.section : 0, {
                    duration: 500,
                    offset: -70,
                    smooth: true,
                  });
                }}
              >
                {option.name}
              </MenuItem>
            ))}
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );

  return (
    <div style={{ display: "flex" }}>
      {
        <React.Fragment key="top">
          <Button
            className={classes.root}
            onClick={() => (state ? toggleDrawer(false) : toggleDrawer(true))}
          >
            <MenuIcon style={{ color: props.menuBackgroundColor }} />
          </Button>
          <Drawer
            anchor={"right"}
            open={state}
            onClose={() => toggleDrawer(false)}
            style={{ zIndex: "1" }}
            classes={{ paper: classes.drawerPaper }}
          >
            {list()}
          </Drawer>
        </React.Fragment>
      }
    </div>
  );
}

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const MenuItem = styled.div`
  display: flex;
  margin: 5px 0;
  padding: 10px;
  height: 40px;
  width: 100%;
  font-family: ${theme.fonts.primaryFontSemiBold};
  cursor: pointer;
  border-bottom: 1px solid #e8e8e8;
  margin: auto 0px;
  align-items: center;
`;
